import { Code } from "../../../api/get-notification-template-properties-by-code/get-notification-template-properties-by-code";
import { useNotificationPropertiesByCode } from "../../../model/use-notification-properties-by-code";
import { PropertyTree } from "@/shared/template-properties/ui/property-tree";

export function PropertyTreeByCode({ code }: { code: Code }) {
  const { data } = useNotificationPropertiesByCode(code);

  return (
    <PropertyTree properties={data?.getNotificationPropertiesByCode ?? []} />
  );
}
